import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import { useItem } from 'shared/dynamic-imports';
import styled from 'styled-components';
import { transformIsoStringToDate } from 'utils/helpers';

type Props = {
    disabled: boolean;
    link?: (date: string) => void;
    attribute: any;
}

export default function Date({ disabled, link ,attribute}: Props): JSX.Element {

    const { currentItem } = useItem();
    const currentAttribute = currentItem.attributes.find((item: any) => item.id === attribute.id);

    const formattedDate = transformIsoStringToDate(currentAttribute?.date);

    const onChange = (e: CalendarChangeParams) => {
        const date: Date = e.value as Date;
        if (date && link) {
            const string = date.toISOString();
             link(string);
        }
    }
    return <Wrapper>
        <Calendar
            id="Date"
            dateFormat="dd/mm/yy"
            className="no-border"
            placeholder="00/00/0000"
            disabled={disabled}
            value={formattedDate}
            onChange={onChange}
            inputClassName='p-1 no-border'
        />
    </Wrapper>

}


const Wrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 8px;
    cursor: pointer !important;
`;